// Style dla komponentów autoryzacji
export const authStyles = {
  mainStyle: {
    maxWidth: 650,
    margin: "40px auto",
    background: "#f7f7f7",
    borderRadius: 24,
    boxShadow: "0 8px 40px 0 rgba(25, 118, 210, 0.10)",
    padding: 40,
    minHeight: 340,
    position: "relative"
  },
  inputStyle: {
    width: "100%",
    marginBottom: 20,
    padding: 14,
    border: "1px solid #bbb",
    borderRadius: 8,
    fontSize: 18,
    boxSizing: "border-box"
  },
  buttonStyle: {
    width: "100%",
    padding: 16,
    background: "linear-gradient(90deg, #ffd700 0%, #ffb300 100%)",
    color: "#222",
    border: "none",
    borderRadius: 8,
    fontWeight: "bold",
    fontSize: 18,
    cursor: "pointer",
    marginTop: 12,
    boxShadow: "0 2px 8px 0 rgba(255, 215, 0, 0.10)",
    transition: "background 0.2s"
  }
}; 